import React, { useState, useEffect } from "react";
import TableScaleBrand from "../../../../components/lists/scaleBrandList/index";
import MenuAdmin from "../../../../components/layout/menu";
import ResetFiltersButton from "../../../../components/filters/resetFiltersButton/index";
import FilterButton from "../../../../components/filters/filterButton/index";
import SearchInput from "../../../../components/filters/searchInput/index";
import ExportButton from "../../../../components/shared/exportButton";
import { getScaleBrand } from "../../../../client/administration/scaleBrand";
import * as XLSX from 'xlsx';
import {  RiAddFill } from "react-icons/ri";
import ContentLoader from 'react-content-loader'; // Importamos el ContentLoader
import Programate from "../../../../components/layout/footer";

const ScaleBrand = () => {
  const [currentRecordsCount, setCurrentRecordsCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); 

  const [brandName, setBrandName] = useState("");  

  const [searchTerm, setSearchTerm] = useState("");
  
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const [showModalAddScale, setShowModalAddScale] = useState(false);

  const openModalAddScale = () => {
    setShowModalAddScale(true);
  };

  const closeModalAddScale = () => {
    setShowModalAddScale(false);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); 

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);  

    useEffect(() => {
      const fetchScaleBrands = async () => {
        try {
          const response = await getScaleBrand();
         // console.log("Registros obtenidos:", response.data); // Verifica los registros obtenidos

          setRecords(response.data);
          setFilteredRecords(response.data);
        } catch (error) {
          console.error('Error fetching scales:', error);
        } finally {
          setLoading(false); // Detener el loading después de obtener los datos
        }
      };
  
      fetchScaleBrands();
    }, []);
  
  
  // Función para restablecer los filtros
  const handleResetFilters = () => {
    setBrandName(""); 
    setSearchTerm("");
  };

  const handleSearch = (value) => {
    setSearchTerm(value); // Actualiza el estado del término de búsqueda
    const lowerCaseValue = value.toLowerCase(); // Convierte el valor a minúsculas para comparación
  
    const filtered = records.filter(record => {
      const brandMatches = record.brandName.toLowerCase().includes(lowerCaseValue);
      return brandMatches ;
    });
  
    setFilteredRecords(filtered);
  };


  const handleExportToExcel = () => {
    console.log("Datos a exportar:", filteredRecords); // Verifica los datos

    const exportData = records.map(record => ({
      id: String(record.id),
      Marca: record.brandName,
      FechaRegistro: new Date(record.createdAt).toLocaleString()
    }));
  
    const ws = XLSX.utils.json_to_sheet(exportData);
    console.log("Hoja de cálculo creada:", ws); // Verifica la estructura de la hoja

    // títulos de las columnas
    ws['A1'].v = 'ID';
    ws['B1'].v = 'Marca';
    ws['C1'].v = 'Fecha Registro';
  
    for (let i = 2; i <= exportData.length + 1; i++) {
      ws[`A${i}`].s = { alignment: { horizontal: "left" } };
      ws[`B${i}`].s = { alignment: { horizontal: "left" } };
      ws[`C${i}`].s = { alignment: { horizontal: "left" } };
    }
    //  ancho de las columnas
    ws['!cols'] = [
      { wch: 10 }, //  (ID)
      { wch: 20 }, //  (Marca)
      { wch: 25 }, //  (Fecha registro)

    ];
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Marca-balanzas");
  
    XLSX.writeFile(wb, "marca-balanzas.xlsx");
  };

  const handleRecordsCountChange = (event) => {
    const newCount = parseInt(event.target.value, 10);
    setCurrentRecordsCount(newCount); // Actualiza el número de registros por página
    setCurrentPage(1); // Reinicia a la primera página
  };

  const isExportDisabled = filteredRecords.length === 0; 

  return (
    <div className="flex w-full min-h-screen ">
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1  transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[83%] `}>
        <div className="flex flex-col justify-between min-h-screen">
          <div className="px-[3%] pb-12">
            {loading ? (
              <div className="pt-32 pb-8 -space-y-2 sm:-space-y-20">
                {/* Skeleton para el título */}
                <ContentLoader
                  viewBox="0 0 1200 200"
                  height="100%"
                  width="100%"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                  <rect x="0" y="0" width="33%" height="40" rx="5" ry="5" /> {/* Título "Marca de Balanzas" */}
                  <rect x="0" y="120" width="24%" height="40" rx="5" ry="5" /> {/* Botón "Agregar marca de balanza" */}
                  <rect x="76%" y="60" width="13%" height="40" rx="5" ry="5" /> {/* Botón "Reset" */}
                  <rect x="90%" y="60" width="10%" height="40" rx="5" ry="5" /> {/* Botón "Exportar" */}
                  <rect x="76%" y="120" width="25%" height="40" rx="5" ry="5" /> {/* Barra de búsqueda */}
                </ContentLoader>
    
                {/* Skeleton para la tabla */}
                <ContentLoader
                  width="100%"
                  height="100%"
                  viewBox="0 0 1500 400"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ecebeb"
                  speed={5}
                >
                   {/* Columnas de la tabla */}
                  <rect x="0%" y="139" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="140" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="141" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="142" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="143" rx="10" ry="10" width="12%" height="19" />
    
                  <rect x="0%" y="196" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="197" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="198" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="197" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="198" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="258" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="259" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="260" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="259" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="260" rx="10" ry="10" width="12%" height="19" />
              
                  <rect x="0%" y="316" rx="4" ry="4" width="5%" height="20" />
                  <rect x="7%" y="317" rx="10" ry="10" width="35%" height="19" />
                  <rect x="44%" y="318" rx="10" ry="10" width="25%" height="19" />
                  <rect x="72%" y="317" rx="10" ry="10" width="12%" height="19" />
                  <rect x="86%" y="318" rx="10" ry="10" width="12%" height="19" />
                </ContentLoader>
              </div>
            ) : (
              <div className="pt-28 md:pt-28 lg:pt-28 2xl:pt-[7rem]">
                <h1 className="text-[32px] font-itcbold text-[#007696] text-center lg:text-left ">Marca de Balanzas</h1>
    
                <div className="flex flex-col items-start justify-center">
                  {/* Filtros */}
                  <div className="flex flex-col-reverse items-start w-full gap-2 pt-4 md:pt-0 md:items-center md:flex-row ">
                    <div className="flex flex-row items-start w-full my-4 md:gap-2 md:space-y-0 lg:space-x-5 ">
                    <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    /> 
                    </div> 
                  </div>
    
                  <div className="flex flex-col-reverse items-start w-full gap-5 pt-1 mb-4 lg:gap-0 md:justify-between md:items-center md:flex-row ">
                    <div className="flex items-center justify-center w-full md:justify-start">
                      <button
                        onClick={openModalAddScale}
                        className="flex items-center justify-center h-[40px] p-3 px-5 space-x-4 text-white rounded-md bg-green"
                      >
                        <RiAddFill className="flex text-[14px] font-itcmedium" /> 
                          Agregar marca de balanza
                      </button>
                    </div>
                    

                    <div className="flex items-center justify-between w-full gap-2 md:justify-end ">
                       <ResetFiltersButton 
                          onClick={handleResetFilters}
                       /> 
                       <ExportButton onClick={handleExportToExcel}  disabled={isExportDisabled}/>  
</div> 
                  </div> 
                  <TableScaleBrand
                    data={records}
                    recordsPerPage={currentRecordsCount}  
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    searchTerm={searchTerm}
                    onSearchTermChange={handleSearch}
                    showModalAddScale={showModalAddScale}
                    closeModalAddScale={closeModalAddScale}
                  />
                </div>
              </div>
            )}
          </div>
          <Programate/>
        </div>
      </div>            
    </div> 
  );
};

export default ScaleBrand;